module.exports = __webpack_public_path__ + "static/media/dashboard.1b2c6bb3.jpg";